import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { RPublicFooter } from './RPublicFooter';
import { RPublicHeader } from './RPublicHeader';

interface RPublicLayoutProps {
    children: React.ReactNode;
}

export function RPublicLayout({ children }: RPublicLayoutProps) {
    return (
        <PageShell>
            <RPublicHeader />
            <Main>{children}</Main>
            <RPublicFooter />
        </PageShell>
    );
}

const PageShell = styled('div')({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: Colors.faintGrey,
});

const Main = styled('main')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
});
